import React from "react";
import { Button, Tooltip } from "antd";
import { MdOutlineSchool } from "react-icons/md";
import Cookies from "js-cookie";
import { toast } from "react-toastify";
import { baseURL } from "config/index";

const AcademyAppButton = ({
  label = "Training",
  icon = <MdOutlineSchool size={18} />,
  color = "#819c22",
}) => {
  const handleOpenAcademy = () => {
    const token = Cookies.get("token");
    if (!token) {
      toast.error("Authentication token not found.");
      return;
    }

    // Env-driven (config/env.js ENV switch): prod → acadamy.traya.health, dev → traya-academy.dev.hav-g.in.
    // For a localhost run, set ACADEMY_URL in config/env.js. Guard + fallback so a build where the
    // allowlist key is missing can't throw "Cannot read properties of undefined (reading 'replace')".
    const targetBase = baseURL?.ACADEMY_URL || "https://acadamy.traya.health";

    const academyUrl = targetBase.replace(/\/+$/, "");
    const ssoUrl = `${academyUrl}/api/auth/crm-sso?token=${encodeURIComponent(token)}`;
    window.open(ssoUrl, "_blank");
  };

  return (
    <div className="mx-1">
      <Tooltip title="Open Traya Training Academy" placement="bottom">
        <Button
          shape="round"
          onClick={handleOpenAcademy}
          className="flex items-center px-3 font-medium"
          style={{ height: "35px", color, borderColor: "#c4dd70" }}
          icon={icon}
        >
          {label}
        </Button>
      </Tooltip>
    </div>
  );
};

export default AcademyAppButton;
